<template>
  <div class="send-log-page">
    <van-nav-bar title="发送任务列表" left-text="返回" left-arrow @click-left="onClickLeft" fixed />

    <div class="contents">

      <!-- 发送记录列表 -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        class="send-log-list"
        v-if="sendLogs.length > 0 || loading"
      >
        <div class="log-list-container">
          <div 
            v-for="item in sendLogs" 
            :key="item.id"
            class="log-item"
          >
            <!-- 头部信息 -->
            <div class="log-header">
              <div>{{ item.send_type_text }}</div>
              <div class="log-status" :style="{ color: getStatusColor(item.status) }">{{ item.status_text }}</div>
            </div>
            
            <!-- 消息内容 - 单独占一行 -->
            <div class="message-content">
              <div class="message-text">{{ item.send_msg }}</div>
            </div>
            
            
            <!-- 底部操作 -->
            <div class="log-footer">
              <span class="info-value">{{ item.send_time }}</span>
              <van-button 
                size="mini" 
                type="danger" 
                @click="handleDelete(item.id)"
                class="delete-btn"
              >删除</van-button>
            </div>
          </div>
        </div>
      </van-list>
      
      <!-- 使用van-empty组件显示空状态 -->
      <van-empty
        v-if="!loading && sendLogs.length === 0"
        image="search"
        description="暂无发送记录"
        class="empty-container"
      />
    </div>
  </div>
</template>

<script>
import { Toast, Dialog, Empty } from 'vant';
import { getMsgSendTaskList, delMsgSendTask } from '../../api/robot';

export default {
  components: {
    VanEmpty: Empty
  },
  data() {
    return {
      sendLogs: [],
      loading: false,
      finished: false,
      page: 1,
      pageSize: 10
    };
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    initData() {
      this.page = 1;
      this.sendLogs = [];
      this.finished = false;
      this.loadTaskList();
    },

    // 加载任务列表
    loadTaskList() {
      getMsgSendTaskList({
        page: this.page,
        perPage: this.pageSize
      }).then(res => {
        if (res.code === 1) {
          const newData = res.data.list || [];
          
          // 添加到列表
          this.sendLogs = [...this.sendLogs, ...newData];
          
          // 判断是否加载完毕
          this.finished = this.sendLogs.length >= res.data.page.total;
        } else {
          Toast.fail(res.msg || '获取数据失败');
        }
      }).catch(error => {
        console.error('获取任务列表失败:', error);
        Toast.fail('获取数据失败');
      }).finally(() => {
        this.loading = false;
      });
    },

    // 加载更多数据
    onLoad() {
      this.page++;
      this.loadTaskList();
    },

    // 获取状态对应的颜色
    getStatusColor(status) {
      const colorMap = {
        1: '#07c160', // 成功
        2: '#ff976a', // 部分失败
        3: '#ee0a24', // 失败
        0: '#1989fa'  // 进行中/待处理
      };
      return colorMap[status] || '#999';
    },
    
    // 删除任务
    handleDelete(id) {
      Dialog.confirm({
        title: '确认删除',
        message: '确定要删除这个任务吗？',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        delMsgSendTask({ id }).then(res => {
          if (res.code === 1) {
            Toast.success('删除成功');
            // 重新加载数据
            this.initData();
          } else {
            Toast.fail(res.msg || '删除失败');
          }
        }).catch(error => {
          console.error('删除任务失败:', error);
          Toast.fail('删除失败');
        });
      }).catch(error => {
        // 忽略取消操作的错误
        if (error !== 'cancel') {
          console.error('对话框操作失败:', error);
        }
      });
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('zh-CN');
    },

    // 返回上一页
    onClickLeft() {
      this.$router.back();
    }
  }
};
</script>

<style scoped lang="less">
.send-log-page {
  box-sizing: border-box;
  line-height: 1.5;
  padding-top: 0;
}

.contents {
  padding-top: calc(var(--base-px-16) + var(--base-px-44)); 
  padding-bottom: var(--base-px-16);
}

.log-list-container {
  padding: 0 var(--base-px-16);
}

/* 列表项样式 - 符合Vant卡片设计风格 */
.log-item {
  background-color: #fff;
  border-radius: var(--base-px-8);
  padding: var(--base-px-16);
  margin-bottom: var(--base-px-12);
  box-shadow: 0 var(--base-px-1) var(--base-px-2) rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  border: var(--base-px-1) solid #e5e5e5;
}

/* 适配移动端，移除hover效果 */
.log-item:active {
  background-color: #f8f8f8;
}

/* 头部信息样式 */
.log-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--base-px-12);
}

.log-header > div:first-child {
  font-size: var(--base-px-14);
  font-weight: 500;
  color: #323233;
}

.log-status {
  font-size: var(--base-px-12);
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 12px;
  background-color: rgba(0, 0, 0, 0.05);
}

/* 消息内容样式 */
.message-content {
  margin-bottom: var(--base-px-16);
  border-radius: var(--base-px-8);
  padding: var(--base-px-12);
}

.message-text {
  font-size: var(--base-px-14);
  color: #323233;
  line-height: 1.6;
  word-break: break-word;
  white-space: pre-wrap;
}

/* 底部样式 */
.log-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f0f0f0;
  padding-top: var(--base-px-12);
}

.info-value {
  font-size: var(--base-px-14);
  color: #666;
}

/* 按钮样式 - 符合Vant规范 */
.delete-btn {
  min-width: var(--base-px-52);
  font-size: var(--base-px-12);
  padding: 0 var(--base-px-12);
}

/* 空状态样式 */
.empty-container {
  padding: var(--base-px-60) 0;
  margin-top: var(--base-px-20);
}
</style>